export default "__VITE_ASSET__CsSWKghe__"